module.exports = __webpack_public_path__ + "static/media/square-border.fb806a76.png";